export const SET_INITIAL = 'SET_INITIAL_DATA'
export const SET_LOCALE = 'SET_LOCALE_ACTIVE'
export const SET_LOCALES = 'SET_AVAILABLE_LOCALES'
export const SET_PAGE = 'SET_PAGE_DATA'
export const SET_DOMAIN = 'SET_DOMAIN'
